import * as React from 'react';
import { RANDOMCOLORS } from "../utils/utils";
const { useState, useEffect } = React;

const MAINCOLORS = ["#0092a0", "#D16200", "#DCAD00"];
const getCicleChartData = (dataLength) => {
  const randomColors = dataLength - MAINCOLORS.length;
  return [...MAINCOLORS, ...randomColors > 0 ? RANDOMCOLORS(randomColors) : []];
}

export const useColorsCicleChart = (data) => {
  const [state, setState] = useState<any>(() => []);
  useEffect(() => setState(getCicleChartData(data.length)), []);
  return [state, setState];
}



// WEBPACK FOOTER //
// ./src/share/hooks/useCircleChartColors.ts